import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Curacao: Country = {
    identifier: "Curacao",
    name: "Curaçao",
    countryCode: "CW",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇨🇼",
    svgPath: "m 281.94575,429.0484 -0.146,0.041 -0.539,-0.275 -0.445,-0.447 -0.014,-0.233 0.114,0.02 0.116,0.089 0.179,0.316 0.521,0.208 z",
}
